export default __webpack_public_path__ + "static/letters-background-1-image-3bd202ef4750c00309416518e803400f.png";